import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonColorEnum } from '../enums/button-color.enum';

@Component({
  selector: 'app-secondary-button',
  templateUrl: './secondary-button.component.html',
  styleUrls: ['./secondary-button.component.scss']
})
export class SecondaryButtonComponent {
  @Input() label: string = '';
  @Input() icon: string = '';
  @Input() right: boolean = false;
  @Input() enabled: boolean = true;
  @Input() color: ButtonColorEnum = ButtonColorEnum.primary;
  @Input() widthFull: boolean = false;
  @Input() loading: boolean = false;

  @Output() clickFunc: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  handleButtonClick(event: MouseEvent) {
    if (this.enabled) {
      this.clickFunc.emit(event);
    }

    if (!this.loading && this.enabled) {
      this.clickFunc.emit(event);
    }
  }
}
